import axios from 'axios';
import { API } from '../../../config/api';

const http = axios.create({
  baseURL: API.BACKEND,
  timeout: 10000
});

http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export async function fetchDrums(params = {}) {
  const { data } = await http.get('/api/v1/drums', { params });
  return data;
}

export async function fetchDrum(id) {
  const { data } = await http.get(`/api/v1/drums/${id}`);
  return data;
}

export async function createDrum(payload) {
  const { data } = await http.post('/api/v1/drums', payload);
  return data;
}

export async function updateDrum({ id, ...payload }) {
  const { data } = await http.patch(`/api/v1/drums/${id}`, payload);
  return data;
}

export async function deleteDrum(id) {
  const { data } = await http.delete(`/api/v1/drums/${id}`);
  return data;
}

export async function seedDrums() {
  const { data } = await http.post('/api/v1/drums/seed');
  return data;
}
